import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  Button,
  useTheme,
} from "@mui/material";

import { ReactComponent as WelcomeCardSvg } from "../../assets/images/Group.svg";
import DesignBoxImg from "../../assets/images/Group 1171275971.png";

export interface WelcomeCardProps {
  title: string;
  description: string;
  userName?: string;
  avatar?: string;
  backgroundColor?: string;
  textColor?: string;
  showDecorations?: boolean;
  actionButton?: {
    text: string;
    onClick: () => void;
  };
}

const WelcomeCard: React.FC<WelcomeCardProps> = ({
  title,
  description,
  userName, 
  backgroundColor = "linear-gradient(90deg, #017CC9, #009DFF)",
  textColor = "#fff",
  showDecorations = true,
  actionButton,
}) => {
  const theme = useTheme();

  

  return (
    <Card
      sx={{
        borderRadius: 1,
        color: textColor,
        background: backgroundColor,
        position: "relative",
        overflow: "hidden",
      }}
    >
      <CardContent
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          zIndex: 1,
          p: 0,
          "&:last-child": {
            paddingBottom: 0, // overrides the default
          },
        }}
      >
        {/* Left Illustration */}
        <WelcomeCardSvg
          style={{
            width: "265px",
            height: "177px",
            padding: "24px",
          }}
        />

        {/* Text content */}
        <Box sx={{ flexGrow: 1 }}>
          <Typography variant="h6" fontWeight="400" fontSize={"14px"}>
            Hi, {userName}
          </Typography>
          <Typography variant="subtitle1" fontWeight="700" fontSize={"28px"}>
            {title}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              fontSize:"14px",
              fontWeight:'400',
              mt: 0.5,
              color:
                textColor === "#fff" ? theme.palette.grey[200] : "grey.700",
            }}
          >
            {description}
          </Typography>

          {/* Action Button */}
          {actionButton && (
            <Button
              variant="outlined"
              size="small"
              onClick={actionButton.onClick}
              sx={{
                color: "#fff",
                borderColor: "rgba(255,255,255,0.4)",
                backgroundColor: "rgba(255,255,255,0.15)",
                "&:hover": {
                  backgroundColor: "rgba(255,255,255,0.25)",
                },
                backdropFilter: "blur(6px)",
                borderRadius: 2,
                textTransform: "none",
              }}
            >
              {actionButton.text}
            </Button>
          )}
        </Box>

        {/* Right Side Image instead of decorations */}
        {showDecorations && (
          <Box
            component="img"
            src={DesignBoxImg}
            alt="Design decoration"
            sx={{
              width: 217,
              height: 182,
              mr: 5,
              p: "24px",
            }}
          />
        )}
      </CardContent>
    </Card>
  );
};

export default WelcomeCard;
